import _ from 'lodash';

export class Position2D {
  y;
  x;

  constructor (x, y) {
    this.x = x;
    this.y = y;

    this.addX = this.addX.bind(this);
    this.addY = this.addY.bind(this);
    this.copy = this.copy.bind(this);
    this.toArray = this.toArray.bind(this);
  }

  addX (x) {
    this.x += x;
    return this;
  }

  addY (y) {
    this.y += y;
    return this;
  }

  copy () {
    return _.cloneDeep(this);
  }

  toArray () {
    return [this.x, this.y];
  }
}
